var map = {
	"./boss.md": "9968",
	"./camp2017.md": "633a",
	"./credit-card-calc.md": "7995",
	"./emo.md": "0a31",
	"./flag.md": "dac1",
	"./gomoku.md": "2ea3",
	"./koasu.md": "8e58",
	"./leetcode-night.md": "9a15",
	"./mcip-cms.md": "664f",
	"./mcip.md": "bb81",
	"./realtime.md": "77e8",
	"./shanlinliang.md": "1641",
	"./tic-tac-toe.md": "d4d9",
	"./typingtyping.md": "d279"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "728a";